import * as changeCase from "change-case";
import { includes, last } from "lodash";
import moment from "moment";

export const changeCaseOn = (changeCaseTo, obj, skipProps = []) => {
  const newObject = Array.isArray(obj) ? [] : {};

  Object.keys(obj).forEach(prop => {
    if (typeof obj[prop] === "object" && obj[prop] !== null) {
      newObject[changeCase[changeCaseTo](prop)] = changeCaseOn(changeCaseTo, obj[prop]);
    } else if (!["_destroy", ...skipProps].includes(prop)) {
      newObject[changeCase[changeCaseTo](prop)] = obj[prop];
    } else {
      newObject[prop] = obj[prop];
    }
  });
  return newObject;
};

export const createFormData = (formData, key, data, skipProps = []) => {
  if (data === Object(data) || Array.isArray(data)) {
    Object.keys(data).forEach(i => {
      if (!skipProps.includes(i)) {
        createFormData(formData, `${key}[${i}]`, data[i]);
      } else {
        formData.append(`${key}[${i}]`, data[i]);
      }
    });
  } else {
    formData.append(key, data);
  }
};

export const dateTimeInterval = (startDate, endDate, withDate = true) => {
  const safeStartDate = moment(startDate);
  const safeEndDate = moment(endDate);
  if (withDate) {
    if (safeStartDate.isSame(moment(safeEndDate), "day")) {
      return safeStartDate.format("DD/MM/YYYY HH:mm") + safeEndDate.format(" - HH:mm");
    }
    return safeStartDate.format("DD/MM/YYYY HH:mm") + safeEndDate.format(" - DD/MM/YYYY HH:mm");
  }

  return safeStartDate.format("HH:mm") + safeEndDate.format(" - HH:mm");
};

export const errorsForFormik = ({
  error: {
    response: {
      data: { errors = [] }
    }
  }
}) => {
  return errors.map(error => {
    const pointer = error?.source?.pointer;
    const field = includes(pointer, "/data/attributes/") ? last(pointer.split("/")) : null;
    if (field) {
      return {
        // TODO complete HERE
      };
    }
    return null;
  });
};
